// ** react imports
import { useEffect, useState } from 'react';

// ** router imports
import { Navigate, useLocation } from 'react-router-dom';

// ** util imports
import SessionStorage from '../../utils/SessionStorage';

// ** enums imports
import { USER_ROLES } from '../../enums/common';

const ManagerProtectedRoute = ({ children }) => {
  // states
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // vars
  const token = SessionStorage.get('token');
  const users = JSON.parse(SessionStorage.get('users') || '{}');

  // hooks
  const location = useLocation();

  useEffect(() => {
    if (token && Object.keys(users).length > 0) {
      setIsAuthenticated(true);
    }
  }, [token, users]);

  if (!token && !isAuthenticated) {
    return <Navigate to="/auth/signin" state={{ from: location }} replace />;
  } else if (users.role === USER_ROLES.MANAGER) {
    return (
      <Navigate to="/error/unauthorized" state={{ from: location }} replace />
    );
  } else {
    return children;
  }
};

export default ManagerProtectedRoute;
